// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"8":"cfb9adb3994b7ed58674e5cdb26d0886a14db992","245":"component---src-pages-index-tsx","265":"component---src-templates-page-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"8":"a5a42ec04a4c91fb2548","245":"e313f19b5e45e1f126a1","265":"b91870c1e1dec6684716","453":"f202a9d28c6a7a64b2bc"}[chunkId] + ".js";
};